angular.module('iqxCore').controller('AuthCtrl', function ($scope, authSvc, $routeParams, loginSvc) {
  loginSvc.setLoggedOut() // set them to logged out as they are on the login page
  authSvc.logout()
  $scope.missingParams = false

  if (!$routeParams.goto) {
    $scope.missingParams = true
    console.error('Error', 'Missing GoTo.')
    return
  } else {
    localStorage.setItem('usingAuth0', true)
    if ($routeParams.personid) {
      localStorage.setItem('personid', $routeParams.personid)
    } else {
      localStorage.setItem('personid_from_auth0', true)
    }
    localStorage.setItem('goto', $routeParams.goto)
    authSvc.login()
  }
})
